<template><component v-bind:is="name"></component> </template>
<script>
export default {
    name: 'icon',
    props: ['name'],
};
</script>
